import React from 'react';

const copyToClipboard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const PromptButton = ({ lesson }) => {
  const handleClick = () => {
    if (!lesson) return;
    const prompt = `Please generate a lesson for UK Key Stage 2 students (Lower KS2, Year ${lesson.year_id}). The content will be accessed on an online learning platform.

**Requirements**:
1. **Content**: Well-structured, engaging, and suitable for children aged 7–9.
2. **Language**: Simple, clear, and age-appropriate.
3. **Images**: Only include placeholders with clear descriptions for essential visuals.
4. **Format**:
    - **Lesson Objectives**: Use first-person language (e.g., "you will learn").
    - **Explanation**: Clearly explain the topic.
    - **Scenarios**: Provide at least 3 scenarios to demonstrate key points.
    - **Summary**: Recap the lesson.

**Variables**:
- Lesson Title: ${lesson.title}
- Objectives: ${lesson.objectives}
- Year: ${lesson.year_id}
- Difficulty Level: ${lesson.difficulty_level}
- Lesson ID: ${lesson.id}

**Notes**:
- Keep formatting rich text-friendly (no lines, numbering, or complex symbols).
- Limit sums to simple characters.

**Age Reference**:
- Year 3: 7–8 | Year 4: 8–9.



    
    
    ` // Add more dynamic content as needed
    copyToClipboard(prompt);
    alert('Prompt copied to clipboard.');
  };

  return (
    <button onClick={handleClick}>Lower KS2 LESSON Prompt</button>
  );
};

export default PromptButton;
